import { render, staticRenderFns } from "./courseDetails.vue?vue&type=template&id=25f164f2&scoped=true"
import script from "./courseDetails.vue?vue&type=script&lang=js"
export * from "./courseDetails.vue?vue&type=script&lang=js"
import style0 from "./courseDetails.vue?vue&type=style&index=0&id=25f164f2&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f164f2",
  null
  
)

export default component.exports